export const MIN_PAGINATION_SIZE = 5;
export const MAX_PAGINATION_SIZE = 100;
